import { MutableRefObject, useState } from 'react';

import {
  GridApiPro,
  GridPreferencePanelsValue,
  gridClasses,
  gridPreferencePanelStateSelector,
} from '@mui/x-data-grid-pro';

type Args = {
  apiRef: MutableRefObject<GridApiPro>;
};

const useAssignPanelAnchor = ({ apiRef }: Args) => {
  const [filtersAnchor, setFiltersAnchor] = useState<HTMLElement | null>(null);
  const [columnsAnchor, setColumnsAnchor] = useState<HTMLElement | null>(null);

  const assignAnchor = () => {
    const { openedPanelValue } = gridPreferencePanelStateSelector(
      apiRef.current.state,
    );

    if (
      openedPanelValue === GridPreferencePanelsValue.columns &&
      columnsAnchor
    ) {
      return columnsAnchor;
    }

    if (
      openedPanelValue === GridPreferencePanelsValue.filters &&
      filtersAnchor
    ) {
      return filtersAnchor;
    }

    const columnHeadersElement =
      apiRef.current.rootElementRef?.current?.querySelector(
        `.${gridClasses.columnHeaders}`,
      );

    return columnHeadersElement as HTMLElement;
  };

  return {
    filtersAnchor,
    columnsAnchor,
    setFiltersAnchor,
    setColumnsAnchor,
    assignAnchor,
  };
};

export default useAssignPanelAnchor;
